import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const displayTime = (value) =>
  value && moment(value).isValid() ? moment(value).format('HH:mm') : display(value);

const fileLink = (url, name) =>
  url ? (
    <a href={url} target='_blank' rel='noreferrer'>
      {name || url}
    </a>
  ) : (
    '—'
  );

const htmlField = (html) =>
  html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : '—';

export const getStoreEventViewSections = (
  t,
  item,
  { isShoppingCenter, shoppingCenters, companyCategories } = {},
) => {
  if (!item?.id) {
    return [];
  }

  const shoppingCenterTitle =
    item.shopping_center_title ||
    shoppingCenters?.find((i) => String(i.value) === String(item.shopping_center_id))
      ?.title;

  const companyCategoryTitles =
    item.allData?.company_categories?.map((c) => c.title).join(', ') ||
    (item.company_category_ids || [])
      .map(
        (id) =>
          companyCategories?.find((c) => String(c.value) === String(id))?.title,
      )
      .filter(Boolean)
      .join(', ');

  const contractorTitles =
    item.allData?.contractors?.map((c) => c.title).join(', ') || '—';

  const sections = [
    {
      title: t('Info'),
      fields: [
        { text: t('Titolo IT'), value: display(item.title_it) },
        { text: t('Titolo EN'), value: display(item.title_en) },
        { text: t('Titolo FR'), value: display(item.title_fr) },
      ],
    },
    {
      title: t('Date'),
      fields: [
        {
          text: t('Inizio pubblicazione'),
          value: displayDate(item.start_publishing_at),
        },
        {
          text: t('Data inizio promozione'),
          value: displayDate(item.date_from),
        },
        { text: t('Inizio dalle ore'), value: displayTime(item.time_from) },
        {
          text: t('Data fine promozione'),
          value: displayDate(item.date_to),
        },
        { text: t('Fino alle ore'), value: displayTime(item.time_to) },
        {
          text: t('Data scadenza adesione'),
          value: displayDate(item.membership_expiration_date),
        },
      ],
    },
    {
      title: t('Descrizione'),
      fields: [
        {
          text: t('Descrizione IT'),
          value: htmlField(item.description_it),
        },
        {
          text: t('Descrizione EN'),
          value: htmlField(item.description_en),
        },
        {
          text: t('Descrizione FR'),
          value: htmlField(item.description_fr),
        },
      ],
    },
    {
      title: t('Shop'),
      fields: [
        ...(isShoppingCenter
          ? [
              {
                text: t('Shopping center'),
                value: display(shoppingCenterTitle),
              },
              {
                text: t('CATEGORIE'),
                value: display(companyCategoryTitles),
              },
            ]
          : [{ text: t('Insegna'), value: display(item.company) }]),
      ],
    },
    {
      title: t('Opzioni'),
      fields: [
        {
          text: t('Fino esaurimento scorte'),
          value: displayBool(item.until_last, t),
        },
        {
          text: t('Solo per dipendenti'),
          value: displayBool(item.staff_only, t),
        },
        { text: t('In evidenza'), value: displayBool(item.evidence, t) },
        { text: t('Stato'), value: display(item.published) },
        { text: t('Retail approvato'), value: display(item.retail_approved) },
        {
          text: t('Marketing approvato'),
          value: display(item.marketing_approved),
        },
      ],
    },
    {
      title: t('CANALI DI COMUNICAZIONE'),
      fields: [
        {
          text: 'Uso Archivio (printers)',
          value: displayBool(item.is_archive, t),
        },
        {
          text: 'NEWSLETTER (newsletter)',
          value: displayBool(item.is_newsletter, t),
        },
        { text: 'RADIO VILLAGE (radio)', value: displayBool(item.is_radio, t) },
        { text: 'SOCIAL (social)', value: displayBool(item.is_social, t) },
        { text: 'WEB', value: displayBool(item.is_web, t) },
      ],
    },
  ];

  if (item.allData?.contractors?.length) {
    sections.push({
      title: t('Contractors'),
      fields: [{ text: t('Contractors'), value: contractorTitles }],
    });
  }

  sections.push({
    title: t('Files'),
    fields: [
      {
        text: t('Immagine miniatura (jpg, png, gif)'),
        value: fileLink(
          item.allData?.image_mini,
          item.allData?.image_mini_name,
        ),
      },
      {
        text: t('Immagine(jpg, png, gif)'),
        value: fileLink(item.allData?.image, item.allData?.image_name),
      },
      {
        text: t('Logo(jpg, png, gif)'),
        value: fileLink(item.allData?.logo, item.allData?.logo_name),
      },
      {
        text: t('Video clip(avi, flv, 3gp, wmv, mpeg, mp4, mov)'),
        value: fileLink(
          item.allData?.video_clip,
          item.allData?.video_clip_name,
        ),
      },
    ],
  });

  return sections;
};
